/* eslint-disable */
export default {
  Inbound: 'Eingehend',
  Outbound: 'Ausgehend',
  log: 'Protokoll',
  save: 'Speichern und neu',
  discard: 'Verwerfen und neu',
  hangup: 'Auflegen',
  reject: 'An Voicemail',
  saveDraftAndCreateNewLog:
    'Entwurf speichern und neues Anrufprotokoll erstellen',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
